import {
  InteractivePlayerParametersMenu,
  TInteractivePlayerParametersMenuProps,
} from './interactive-player-parameters-menu';

export { InteractivePlayerParametersMenu, type TInteractivePlayerParametersMenuProps };
